import React, { useState, useEffect } from 'react';
import axios from 'axios';

import { shopContext } from '../../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import { chatbotApi } from '../../../common/src';

const WidgetCart = (props) => {
  //console.log(props);
  const preText = props.childProps.state.prevMessage;
  const _prev = () => {
    props.childProps.actionProvider._categoryPrev(preText);
  };
  const _goHome = () => {
    props.childProps.actionProvider._home(-1);
  };
  const _cart = () => {
    window.open('https://shop.aniplustv.com/order/cart', '', '');
  };
  return (
    <>
      <div className="prev-chat-container">
        <div className="prev-contaner">
          <div className="cart" onClick={_cart}>
            장바구니 바로가기
          </div>
          {preText === '' ||
          preText === undefined ||
          preText === null ? null : (
            <div onClick={_prev} className="prev">
              이전 단계로 이동
            </div>
          )}

          <div onClick={_goHome} className="prev">
            처음으로
          </div>
        </div>
      </div>
    </>
  );
};
export default shopContext(withRouter(WidgetCart));
